import React from 'react'
import { Branch } from '../../../../const'
import { RepositoryProperties } from '../../../../types'
import ReportIcon from '@material-ui/icons/Report'
import { Tooltip } from '@material-ui/core'

//TODO: instead of master/develop const use branching model
export function BranchWarning(props: { repository: RepositoryProperties }) {
  const { repository } = props
  const extraBranches = repository.branches.filter(branch => {
    return !(branch === Branch.master || branch === Branch.main || branch === Branch.develop)
  })
  if (extraBranches.length > 0) {
    return (
      <Tooltip
        arrow
        placement='right'
        title={extraBranches.map(branch => (
          <div>{branch}</div>
        ))}
      >
        <ReportIcon className='margin-left' />
      </Tooltip>
    )
  }
  return null
}
